import { render } from "./CheckoutFreightOptions.vue?vue&type=template&id=0be69658&ts=true"
import script from "./CheckoutFreightOptions.vue?vue&type=script&lang=ts"
export * from "./CheckoutFreightOptions.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__